/************************** BD CUSTOM LABEL SCRIPTS **********************/

(function($) {
    var $ = jQuery = $;
  
    const isIcon = (label) => ['choice-icon', 'heart-icon', 'pills-icon', 'sun-icon', 'rainbow-icon', 'lips-icon', 'jewelry-icon', 'liquid-icon'].includes(label?.trim());
    const isBundle6 = $('html').hasClass('page-the_originals_-_set_of_6');
    const colorType = "color-option";
    const amountType = "gift-card-amount";

    // SELECTIZE - INITIALIZE LABELS
    $('.new-dropdown select').each(function () {
      var $select = $(this).selectize({
        plugins: ['restore_on_backspace'],
        delimiter: ',',
        persist: false,
        create: false,
        form: 'test',
        sortField: [{
          field: 'name',
          direction: 'asc'
        }],
        
        render: {
          option: function (data, escape) {
            let additionalClass = data.value === 'label_free' ? ' custom-selectize-label' : '';
            if (data.disabled) additionalClass += ' disabled';
            let div1 = `<div class="option${additionalClass}"  data-selectable="" data-customize="${data.customize}" data-value="${data.value}">`;
            if (data.type === colorType) {
              div1 =`<div style="display: flex; align-items: center" class="option${additionalClass} color${data.value}" data-product-id="${data.productId}" data-product-name="${data.productName}" data-variant-id="${data.variantId}" data-variant-name="${data.variantName}"  data-selectable="" data-customize="${data.customize}" data-value="${data.value}">`;
            }
            if (isIcon(data.value)) {
              return `${div1}<img src="${data.url}1" style="width: 1.5rem;"></div>`;
            }
            if (data.type === colorType) {
              return `${div1}<span class="color-option ${data.value}"></span>${data.value}</div>`;
            }
            return `${div1}${data.text}</div>`;
          },
          item: function (data, escape) {
            let div1 = `<div class="item" data-labelmessage="${data.text}" data-value="${data.value}">`;
            if (data.type === colorType) {
              div1 = `<div style="display: inline-flex; align-items: center" class="item" data-labelmessage="${data.text}" data-value="${data.value}">`;
            }
            if (isIcon(data.value)) {
              return `${div1}<img src="${data.url}1" style="width: 1.5rem; margin-left:1.5rem;"></div>`;
            }
            if (data.type === colorType) {
              return `${div1}<span class="color-option ${data.value}"></span>${data.value}</div>`;
            }
            return `${div1}${data.value}</div>`;
          }
        },
        onItemAdd: function (value, $item) {
          var data = this.options[value];
          // console.log(data);
        },
        onFocus: function() {
          const input = 'selectize-input input', wrapper = 'selectize-input';
          $(`.${input}`).attr('readonly', true);
          $(`.${input}, .${wrapper}`).css('cursor', 'pointer');
       },
       onChange: function (value) {
         const elem = this.$input[0];
         const select = $(elem).closest('select');
         if (select.data('type') === amountType) {
           const selector = $('.product-image-main .image-wrap p[data-location="gc-properties"] span[data-gift-card-amount]');
           selector.text(value);
         }
       }
      });
  
    });
  
  
  })($);
  